import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import { usePasskey } from './use-passkey'
import { FingerprintIcon } from '../../../icons/Fingerprint'

import "./modal.scss"

export const SetupPasskeyModal = () => {
  const { doAddPasskey, isRegistered, status, isRegistering } = usePasskey()
  const [visible, setVisible] = useState(true)

  return (
    // @ts-ignore
    <Modal
      title="Setup Passkey"
      visible={visible && !isRegistered && status === 'success'}
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <div className="setup-passkey-modal-content">
        <p className="setup-passkey-modal-title">You have not setup passkey yet.</p>
        <p className="setup-passkey-modal-description">
          Passkey is a security feature that allows you to use a physical device
          to authenticate your account.
        </p>

        <Button
          onClick={doAddPasskey}
          isLoading={isRegistering}
          icon={<FingerprintIcon />}
          className="setup-passkey-modal-button"
        >
          Add passkey
        </Button>
      </div>
    </Modal>
  )
}
